import { BuilderComponentGroup } from '../types'
import { UtilityComponents } from './app.group'
import { ButtonComponents } from './buttons.group'
import { ChartComponents } from './charts.group'
import { ContainerComponents } from './containers.group'
import { FormComponents } from './forms.group'
import { GlobalsComponents } from './globals.group'
import { InteractiveComponents } from './interactive.group'
import { ListComponents } from './lists.group'
import { MediaComponents } from './media.group'
import { ProgressComponents } from './progress.group'
import { TableComponents } from './tables.group'
import { TextComponents } from './text.group'
import { VisualComponents } from './visual.group'

export const DEFAULT_COMPONENTS_GROUPS: BuilderComponentGroup[] = [
  ContainerComponents,
  GlobalsComponents,
  TextComponents,
  ButtonComponents,
  MediaComponents,
  ListComponents,
  TableComponents,
  FormComponents,
  VisualComponents,
  ProgressComponents,
  ChartComponents,
  UtilityComponents,
  InteractiveComponents,
  // Add other component groups as they're created
]
